import { MetadataAttachment } from '@jms/model';

/**
 * Whether a user may delete, re-tag or re-share an attachment from the Files tab. Only uploaded files
 * (`isFile`) qualify, and never a read-only one: an integration owns those, and the server refuses the change.
 * Used by the Files dashboard and the file details editor so both offer the same actions.
 */
export function canUserChangeFile(attachment: MetadataAttachment): boolean {

  return attachment?.isFile === true && attachment?.readOnly !== true;
}
